<template>
  <div>
    <div class="main-title marTop64">
      推荐阅读
    </div>
    <div class="main-cates">
      <div
        class="item-block"
        v-for="(item, index) in questionList"
        :key="index"
        :zz-sortid="index"
        :zz-sortname="item.title"
        @click="handleJump(item)"
      >
        <div class="question">{{ item.title }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import native from '@zz-common/native-adapter'
import { lego } from '@zz-common/lego'

const questionList = [
  {
    title: '防骗小知识',
    id: 'kfzx-c1',
    jumpUrl:
        'https://pic1.zhuanstatic.com/zhuanzh/a6fe2289-ef42-41aa-b85a-575283c45e70.png'
  },
  {
    title: '我被骗了怎么办',
    id: 'kfzx-c2',
    jumpUrl:
        'https://pic6.zhuanstatic.com/zhuanzh/e8289de5-9a73-4529-af78-7b432272077b.jpg'
  },
  {
    title: '直接微信转账被骗怎么办',
    id: 10207,
    jumpUrl:
        'https://pic3.zhuanstatic.com/zhuanzh/31702c1e-1171-4084-a8b8-983bbf17fda3.png'
  }
]
export default {
  name: 'CommonQuestion',
  data() {
    return {
      questionList
    }
  },
  methods: {
    handleJump: function(item) {
      lego.send({
        pagetype: 'ZZUP_HELPCENTER',
        actiontype: 'QA_CLICK',
        backup: {
          name: item.id
        }
      })
      native.skipToUrl({
        targetUrl: item.jumpUrl,
        newPageTitle: item.title
      })
    }
  }
}
</script>

<style lang="less" scoped>
  @import 'CommonQuestion.less';
  @import '../HelpCenter.less';
</style>
